import React, { useState } from 'react';
import axios from '../../axios/axiosconf';
import ModalCIE10 from './ModalCIE10';
import SearchableSelect from './SearchableSelect';
import ModalRipsExito from './ModalRipsExito';
import ModalConfirmacionFacturacion from './ModalConfirmacionFacturacion';
import ModalDatosFacturacion from './ModalDatosFacturacion';
import { useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';

function RegistroRipsFev({ paciente, onClose }) {
    const location = useLocation();
    const pacienteIdQuery = new URLSearchParams(location.search).get('id');
    const [formData, setFormData] = useState({
        paciente_id: '',
        nombre_paciente: '',
        tipo: 'CC',
        ndocumento: '',
        fecha: '',
        incapacidad: 'NO',
        tipo_usuario: '12',
        profesionalcode: '',
        tipo_consulta: false,
        tipo_procedimiento: false,
        valorconsulta: '0',
        descuento_consulta: '0',
        impuesto_consulta: '0',
        total_consulta: '0',
        valorprocedimiento: '0',
        descuento_procedimiento: '0',
        impuesto_procedimiento: '0',
        total_procedimiento: '0',
        total_bruto: '0',
        total_pagar: '0',
        cupsc: '',
        cupsp: '',
        cie10c: '',
        cie10c1: '',
        cie10c2: '',
        cie10c3: '',
        cie10p: '',
        cie10p1: '',
        cie10pc: ''
    });

    const [showConsulta, setShowConsulta] = useState(false);
    const [showProcedimiento, setShowProcedimiento] = useState(false);

    // Estados para modales
    const [showModalConsulta, setShowModalConsulta] = useState(false);
    const [showModalProcedimiento, setShowModalProcedimiento] = useState(false);
    const [listaConsultas, setListaConsultas] = useState([]);
    const [listaProcedimientos, setListaProcedimientos] = useState([]);
    
    // Modal de éxito
    const [showModalExito, setShowModalExito] = useState(false);
    const [ripsGuardado, setRipsGuardado] = useState(null);

    // Estados para modales CIE10
    const [showModalCIE10, setShowModalCIE10] = useState(false);
    const [cie10Field, setCie10Field] = useState(''); // Campo actual que se está editando

    // Estados para modal de confirmación de facturación
    const [showModalConfirmacion, setShowModalConfirmacion] = useState(false);
    const [datosRipsTemp, setDatosRipsTemp] = useState(null);

    // Estados para modal de datos de facturación
    const [showModalDatosFacturacion, setShowModalDatosFacturacion] = useState(false);

    // Estados para modal de confirmación envío DIAN
    const [showModalEnvioDian, setShowModalEnvioDian] = useState(false);
    const [facturaIdParaDian, setFacturaIdParaDian] = useState(null);
    
    // Estados para modal de envío en progreso
    const [showModalEnviando, setShowModalEnviando] = useState(false);
    const [mensajeEnvio, setMensajeEnvio] = useState('');
    const [errorEnvio, setErrorEnvio] = useState(null);

    // Modal Bootstrap: borrador creado (sin ModalRipsExito; la factura sigue incompleta)
    const [showModalBorradorExito, setShowModalBorradorExito] = useState(false);
    const [infoBorrador, setInfoBorrador] = useState(null);

    // Estados para datos de API
    const [profesionales, setProfesionales] = useState([]);
    const [parametrosFev, setParametrosFev] = useState([]);
    
    // Estados para JSON de RIPS
    const [servicios, setServicios] = useState([]);
    const [finalidadConsulta, setFinalidadConsulta] = useState([]);
    const [finalidadProcedimiento, setFinalidadProcedimiento] = useState([]);
    const [causaExterna, setCausaExterna] = useState([]);

    // Llenar datos del paciente cuando se reciben las props
    React.useEffect(() => {
        if (paciente) {
            const nombreCompleto = `${paciente.primerNombre || ''} ${paciente.segundoNombre || ''} ${paciente.primerApellido || ''} ${paciente.segundoApellido || ''}`.trim();
            
            // Obtener el ID del usuario logueado para asignarlo como profesional
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            
            setFormData(prev => ({
                ...prev,
                paciente_id: paciente.id || '',
                nombre_paciente: nombreCompleto,
                tipo: paciente.tipoDocumento || 'CC',
                ndocumento: paciente.numeroDocumento || '',
                fecha: new Date().toISOString().split('T')[0],
                profesionalcode: userdata.user_id || '' // Asignar automáticamente el usuario logueado
            }));
        }
    }, [paciente]);

    React.useEffect(() => {
        if (paciente || !pacienteIdQuery) return;

        let userdata = JSON.parse(localStorage.getItem('userdata') || '{}');
        const config = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            params: { id: pacienteIdQuery }
        };

        axios.get('/paciente', config)
            .then(response => {
                const datosPaciente = Array.isArray(response.data) ? response.data[0] : response.data;
                if (!datosPaciente) return;

                const nombreCompleto = `${datosPaciente.primer_nombre || ''} ${datosPaciente.segundo_nombre || ''} ${datosPaciente.primer_apellido || ''} ${datosPaciente.segundo_apellido || ''}`.trim();

                setFormData(prev => ({
                    ...prev,
                    paciente_id: datosPaciente.id || '',
                    nombre_paciente: nombreCompleto,
                    tipo: datosPaciente.tipo_documento || 'CC',
                    ndocumento: datosPaciente.numero_documento || '',
                    fecha: new Date().toISOString().split('T')[0],
                    profesionalcode: userdata.user_id || ''
                }));
            })
            .catch(error => console.log('Error cargando paciente por query id:', error));
    }, [paciente, pacienteIdQuery]);

    // Cargar datos de API
    React.useEffect(() => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: { Authorization: 'Bearer ' + userdata.access_token }
        };

        // Cargar profesionales (para mostrar el nombre del profesional logueado)
        axios.get('/usuarios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setProfesionales(response.data);
                }
            })
            .catch(error => console.log('Error cargando profesionales:', error));

        // Cargar parámetros FEV
        axios.get('/parametros-fev?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setParametrosFev(response.data);
                }
            })
            .catch(error => console.log('Error cargando parámetros FEV:', error));
        
        // Cargar Servicios desde API
        axios.get('/rips-servicios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setServicios(response.data);
                }
            })
            .catch(error => console.log('Error cargando servicios:', error));
        
        // Cargar Finalidad Consulta desde API
        axios.get('/rips-finalidad-consulta?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setFinalidadConsulta(response.data);
                    setFinalidadProcedimiento(response.data); // Usar el mismo para procedimiento
                }
            })
            .catch(error => console.log('Error cargando finalidad consulta:', error));
        
        // Cargar Causa Externa desde API
        axios.get('/rips-causa-externa?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setCausaExterna(response.data);
                }
            })
            .catch(error => console.log('Error cargando causa externa:', error));
    }, []);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        let newFormData = {
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        };

        // Recalcular totales cuando cambien valores monetarios
        if (['valorconsulta', 'descuento_consulta', 'impuesto_consulta', 'valorprocedimiento', 'descuento_procedimiento', 'impuesto_procedimiento'].includes(name)) {
            newFormData = calcularTotales(newFormData);
        }

        setFormData(newFormData);

        if (name === 'tipo_consulta') {
            setShowConsulta(checked);
        } else if (name === 'tipo_procedimiento') {
            setShowProcedimiento(checked);
        }
    };

    const calcularTotales = (data) => {
        const valorConsulta = parseFloat(data.valorconsulta) || 0;
        const descuentoConsulta = parseFloat(data.descuento_consulta) || 0;
        const impuestoConsulta = parseFloat(data.impuesto_consulta) || 0;

        const valorProcedimiento = parseFloat(data.valorprocedimiento) || 0;
        const descuentoProcedimiento = parseFloat(data.descuento_procedimiento) || 0;
        const impuestoProcedimiento = parseFloat(data.impuesto_procedimiento) || 0;

        // Calcular total consulta
        const totalConsulta = valorConsulta - descuentoConsulta + impuestoConsulta;

        // Calcular total procedimiento
        const totalProcedimiento = valorProcedimiento - descuentoProcedimiento + impuestoProcedimiento;

        // Calcular totales generales
        const totalBruto = valorConsulta + valorProcedimiento;
        const totalPagar = totalConsulta + totalProcedimiento;

        return {
            ...data,
            total_consulta: totalConsulta.toString(),
            total_procedimiento: totalProcedimiento.toString(),
            total_bruto: totalBruto.toString(),
            total_pagar: totalPagar.toString()
        };
    };

    const cargarConsultas = async () => {
        try {
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            const config = {
                headers: { Authorization: 'Bearer ' + userdata.access_token },
                params: { uid: userdata.user_id, clasificacionrips: 1 }
            };
            const response = await axios.get('/lista-precio-rips', config);
            setListaConsultas(response.data);
        } catch (error) {
            console.error('Error cargando consultas:', error);
        }
    };

    const cargarProcedimientos = async () => {
        try {
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            const config = {
                headers: { Authorization: 'Bearer ' + userdata.access_token },
                params: { uid: userdata.user_id, clasificacionrips: 2 }
            };
            const response = await axios.get('/lista-precio-rips', config);
            setListaProcedimientos(response.data);
        } catch (error) {
            console.error('Error cargando procedimientos:', error);
        }
    };

    const abrirModalConsulta = () => {
        cargarConsultas();
        setShowModalConsulta(true);
    };

    const abrirModalProcedimiento = () => {
        cargarProcedimientos();
        setShowModalProcedimiento(true);
    };

    const seleccionarConsulta = (item) => {
        const newFormData = { 
            ...formData, 
            cupsc: item.codigorips,
            valorconsulta: item.precio || '0'
        };
        setFormData(calcularTotales(newFormData));
        setShowModalConsulta(false);
    };

    const seleccionarProcedimiento = (item) => {
        const newFormData = { 
            ...formData, 
            cupsp: item.codigorips,
            valorprocedimiento: item.precio || '0'
        };
        setFormData(calcularTotales(newFormData));
        setShowModalProcedimiento(false);
    };

    const abrirModalCIE10 = (fieldName) => {
        setCie10Field(fieldName);
        setShowModalCIE10(true);
    };

    const seleccionarCIE10 = (codigo) => {
        setFormData(prev => ({ ...prev, [cie10Field]: codigo }));
        setShowModalCIE10(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validaciones básicas
        if (!formData.tipo_consulta && !formData.tipo_procedimiento) {
            alert('Debe seleccionar al menos Consulta o Procedimiento');
            return;
        }

        if (!formData.profesionalcode) {
            alert('Por favor complete el campo de Profesional');
            return;
        }

        // Validar Consulta
        if (formData.tipo_consulta) {
            if (!formData.cupsc || !formData.cie10c) {
                alert('Para Consulta, debe seleccionar el Código CUPS y el Diagnóstico Principal');
                return;
            }
        }

        // Validar Procedimiento
        if (formData.tipo_procedimiento) {
            if (!formData.cupsp || !formData.cie10p) {
                alert('Para Procedimiento, debe seleccionar el Código CUPS y el Diagnóstico Principal');
                return;
            }
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));

        const ripsData = {
            ...formData,
            uid: userdata.user_id,
            es_fev: true // Indicador para el controlador
        };

        // ✅ SIEMPRE mostrar modal de confirmación
        setDatosRipsTemp(ripsData);
        setShowModalConfirmacion(true);
    };

    const handleConfirmacionFacturacion = async (facturarAhora) => {
        setShowModalConfirmacion(false);
        
        if (facturarAhora) {
            // Usuario quiere facturar ahora - abrir modal de datos de facturación
            setShowModalDatosFacturacion(true);
        } else {
            // Usuario quiere crear borrador
            await crearFacturaBorrador(datosRipsTemp);
        }
    };

    const handleConfirmarDatosFacturacion = async (datosFacturacion) => {
        setShowModalDatosFacturacion(false);
        
        // Combinar datos de RIPS con datos de facturación
        const ripsCompleto = {
            ...datosRipsTemp,
            ...datosFacturacion
        };
        
        // Guardar RIPS con factura completa
        await guardarRipsNormal(ripsCompleto);
    };

    const guardarRipsNormal = async (ripsData) => {
        try {
            const response = await axios.post('/rips', ripsData);
            if (response.status === 200 || response.status === 201) {
                const ripsId = response.data.rips_id;
                const facturaId = response.data.factura_id;
                
                // Guardar factura ID y mostrar modal de confirmación
                setFacturaIdParaDian(facturaId);
                setShowModalEnvioDian(true);
                
                // Guardar datos para el modal de éxito
                setRipsGuardado({
                    rips_id: ripsId,
                    factura_id: facturaId,
                    tipo: 'fev',
                    estado: 1 // RIPS con factura
                });
            }
        } catch (error) {
            console.error('Error al guardar:', error);
            alert('Error al guardar RIPS: ' + (error.response?.data?.message || error.message));
        }
    };

    const handleConfirmarEnvioDian = async () => {
        setShowModalEnvioDian(false);
        
        if (facturaIdParaDian) {
            // Mostrar modal de "Enviando..."
            setShowModalEnviando(true);
            setMensajeEnvio('Enviando factura a la DIAN...');
            setErrorEnvio(null);
            
            try {
                const envioResponse = await axios.post(`/factura/${facturaIdParaDian}/enviar-dian`, {});
                
                if (envioResponse.data.success) {
                    // Éxito
                    setMensajeEnvio(`✅ Factura enviada exitosamente a la DIAN\n\nUUID: ${envioResponse.data.uuid}`);
                    setErrorEnvio(null);
                } else {
                    // Error en la respuesta
                    setMensajeEnvio('❌ Error al enviar a la DIAN');
                    setErrorEnvio({
                        message: envioResponse.data.message,
                        data: envioResponse.data
                    });
                }
            } catch (envioError) {
                console.error('Error al enviar a DIAN:', envioError);
                
                // Capturar toda la información del error
                setMensajeEnvio('❌ Error al enviar a la DIAN');
                setErrorEnvio({
                    message: envioError.response?.data?.message || envioError.message,
                    status: envioError.response?.status,
                    statusText: envioError.response?.statusText,
                    data: envioError.response?.data,
                    fullError: envioError.response || envioError
                });
            }
        } else {
            // Si no hay factura ID, mostrar modal de éxito directamente
            setShowModalExito(true);
        }
    };

    const handleCancelarEnvioDian = () => {
        setShowModalEnvioDian(false);
        // Mostrar modal de éxito sin enviar a DIAN
        setShowModalExito(true);
    };

    const handleCerrarModalEnviando = () => {
        setShowModalEnviando(false);
        // Mostrar modal de éxito después de cerrar el modal de envío
        setShowModalExito(true);
    };

    const crearFacturaBorrador = async (ripsData) => {
        console.log('🔍 [FRONTEND] Inicio crearFacturaBorrador');
        console.log('🔍 [FRONTEND] Datos RIPS:', ripsData);
        
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        console.log('🔍 [FRONTEND] UserData:', {
            user_id: userdata.user_id,
            access_token: userdata.access_token ? 'PRESENTE' : 'AUSENTE'
        });

        try {
            const config = {
                headers: { Authorization: 'Bearer ' + userdata.access_token }
            };

            // ✅ Preparar items de factura (consulta y/o procedimiento)
            const items = [];
            
            if (ripsData.tipo_consulta && ripsData.cupsc) {
                items.push({
                    cups_code: ripsData.cupsc,
                    tipo: 'consulta',
                    valor: parseFloat(ripsData.valorconsulta || 0),
                    descuento: parseFloat(ripsData.descuento_consulta || 0),
                    impuesto: parseFloat(ripsData.impuesto_consulta || 0),
                    total: parseFloat(ripsData.total_consulta || 0)
                });
            }
            
            if (ripsData.tipo_procedimiento && ripsData.cupsp) {
                items.push({
                    cups_code: ripsData.cupsp,
                    tipo: 'procedimiento',
                    valor: parseFloat(ripsData.valorprocedimiento || 0),
                    descuento: parseFloat(ripsData.descuento_procedimiento || 0),
                    impuesto: parseFloat(ripsData.impuesto_procedimiento || 0),
                    total: parseFloat(ripsData.total_procedimiento || 0)
                });
            }

            console.log('🔍 [FRONTEND] Items preparados:', items);

            const usersIdRips = Number(ripsData.profesionalcode) || Number(userdata.user_id);
            const requestData = {
                paciente_id: Number(ripsData.paciente_id),
                users_id: usersIdRips,
                tipo_factura: 'electronica',
                items: items // ✅ Enviar items de RIPS
            };

            console.log('🔍 [FRONTEND] Datos a enviar:', requestData);
            console.log('🔍 [FRONTEND] Config headers:', config);

            // Paso 1: Crear factura en borrador CON DETALLES
            console.log('🔍 [FRONTEND] Enviando petición POST /facturas/crear-borrador...');
            const facturaResponse = await axios.post('/facturas/crear-borrador', requestData, config);

            console.log('✅ [FRONTEND] Respuesta crear-borrador:', facturaResponse.data);

            if (facturaResponse.status === 200 || facturaResponse.status === 201) {
                const facturaId = facturaResponse.data.factura_id;
                console.log('✅ [FRONTEND] Factura borrador creada con ID:', facturaId);
                console.log('✅ [FRONTEND] Items creados:', facturaResponse.data.items_creados);
                console.log('✅ [FRONTEND] Valor bruto:', facturaResponse.data.valor_bruto);
                console.log('✅ [FRONTEND] Valor total:', facturaResponse.data.valor_total);

                // Paso 2: Crear RIPS asociado a la factura en borrador
                const ripsRequestData = {
                    ...ripsData,
                    factura_id: facturaId,
                    users_id: userdata.user_id
                };

                console.log('🔍 [FRONTEND] Enviando petición POST /rips...');
                console.log('🔍 [FRONTEND] Datos RIPS a enviar:', ripsRequestData);

                const ripsResponse = await axios.post('/rips', ripsRequestData, config);

                console.log('✅ [FRONTEND] Respuesta crear RIPS:', ripsResponse.data);

                if (ripsResponse.status === 200 || ripsResponse.status === 201) {
                    const totalNum = Number(facturaResponse.data.valor_total ?? 0);
                    setInfoBorrador({
                        facturaId,
                        ripsId: ripsResponse.data.rips_id,
                        items: facturaResponse.data.items_creados,
                        total: totalNum
                    });
                    setShowModalBorradorExito(true);
                }
            }
        } catch (error) {
            console.error('❌ [FRONTEND] Error al crear borrador:', error);
            console.error('❌ [FRONTEND] Error response:', error.response?.data);
            console.error('❌ [FRONTEND] Error status:', error.response?.status);
            console.error('❌ [FRONTEND] Error headers:', error.response?.headers);
            
            // Manejar error específico de parámetros FEV no configurados
            if (error.response?.data?.error === 'PARAMETROS_FEV_NO_CONFIGURADOS') {
                const msg = error.response?.data?.message
                    || 'No hay resolución de factura electrónica habilitada para este cliente.';
                alert(`${msg}\n\nEn borrador, el prefijo definitivo se define al completar datos en facturación.`);
            } else {
                const errorMsg = error.response?.data?.message || error.message;
                const errorDebug = error.response?.data?.debug || {};
                alert(`Error al crear factura en borrador: ${errorMsg}\n\nDebug: ${JSON.stringify(errorDebug, null, 2)}`);
            }
        }
    };

    const handleDescargar = async (ripsId) => {
        try {
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            
            // Determinar el endpoint según el estado y factura
            let endpoint;
            let fileName;
            
            if (ripsGuardado && (ripsGuardado.estado === 2 || ripsGuardado.estado === 4) && ripsGuardado.factura_id) {
                // RIPS por convenio con factura - descargar agrupado
                endpoint = `/rips/convenio/${ripsGuardado.factura_id}/descargar`;
                fileName = `rips_convenio_${ripsGuardado.factura_id}`;
            } else {
                // RIPS individual
                endpoint = `/rips/${ripsId}/descargar`;
                fileName = `rips_${ripsId}`;
            }
            
            const response = await axios.get(endpoint, {
                params: { uid: userdata.user_id },
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            
            const contentType = response.headers['content-type'];
            const finalFileName = contentType.includes('zip') 
                ? `${fileName}.zip` 
                : `${fileName}.json`;
            
            link.setAttribute('download', finalFileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error descargando RIPS:', error);
            alert('Error al descargar el archivo RIPS');
        }
    };

    const handleEnviar = async (ripsId) => {
        try {
            const response = await axios.post(`/rips/${ripsId}/enviar`);
            
            if (response.data.success) {
                alert(`RIPS enviado exitosamente\n\nEstado anterior: ${response.data.estado_anterior}\nEstado nuevo: ${response.data.estado_nuevo}`);
                setShowModalExito(false);
                if (onClose) onClose();
            }
        } catch (error) {
            console.error('Error enviando RIPS:', error);
            alert('Error al enviar RIPS: ' + (error.response?.data?.message || error.message));
        }
    };

    const handleCerrarModal = () => {
        setShowModalExito(false);
        if (onClose) onClose();
    };

    const handleCerrarModalBorradorExito = () => {
        setShowModalBorradorExito(false);
        setInfoBorrador(null);
        if (onClose) onClose();
    };

    const pacienteYaCargado = Boolean(
        paciente ||
        (pacienteIdQuery && String(pacienteIdQuery).trim() !== '') ||
        String(formData.paciente_id || '').trim() !== ''
    );

    return (
        <div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
            <form onSubmit={handleSubmit}>
                <div className="card card-info card-outline">
                    <div className="card-header"><b>Información del Paciente</b></div>
                    <div className="card-body">
                        {!pacienteYaCargado && (
                            <div className="form-group">
                                <button type="button" className="btn btn-info">
                                    <i className="fas fa-edit"></i>Seleccionar Paciente
                                </button>
                            </div>
                        )}

                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Nombre del Paciente *</label>
                                    <input type="text" name="nombre_paciente" className="form-control text-uppercase"
                                        value={formData.nombre_paciente} readOnly />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>Tipo *</label>
                                    <select name="tipo" className="form-control" value={formData.tipo} onChange={handleInputChange} required>
                                        <option value="CC">CC</option>
                                        <option value="CE">CE</option>
                                        <option value="PA">PA</option>
                                        <option value="PE">PE</option>
                                        <option value="RC">RC</option>
                                        <option value="TI">TI</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>N°Documento *</label>
                                    <input type="text" name="ndocumento" className="form-control"
                                        value={formData.ndocumento} readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card card-info card-outline">
                    <div className="card-header"><b>Información General</b></div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>Fecha *</label>
                                    <input type="date" name="fecha" className="form-control"
                                        value={formData.fecha} onChange={handleInputChange} required />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>Incapacidad *</label>
                                    <select name="incapacidad" className="form-control" value={formData.incapacidad} onChange={handleInputChange} required>
                                        <option value="NO">NO</option>
                                        <option value="SI">SI</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>Tipo de Usuario *</label>
                                    <select name="tipo_usuario" className="form-control" value={formData.tipo_usuario} onChange={handleInputChange} required>
                                        <option value="12">Particular</option>
                                        <option value="01">Contributivo cotizante</option>
                                        <option value="02">Contributivo beneficiario</option>
                                        <option value="03">Contributivo adicional</option>
                                        <option value="04">Subsidiado</option>
                                        <option value="05">No afiliado</option>
                                        <option value="06">Especial o Excepcion cotizante</option>
                                        <option value="07">Especial o Excepcion beneficiario</option>
                                        <option value="08">Personas privadas de la libertad a cargo del Fondo Nacional de Salud</option>
                                        <option value="09">Tomador / Amparado ARL</option>
                                        <option value="10">Tomador / Amparado SOAT</option>
                                        <option value="11">Tomador / Amparado Planes voluntarios de salud</option>
                                        <option value="13">Especial o Exepcion no cotizante Ley 352 de 1997</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Profesional *</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={profesionales.find(p => p.id === formData.profesionalcode)?.name + ' ' + (profesionales.find(p => p.id === formData.profesionalcode)?.lastname || '') || 'Cargando...'} 
                                        readOnly 
                                        style={{ backgroundColor: '#e9ecef' }}
                                    />
                                    <small className="form-text text-muted">
                                        <i className="fas fa-info-circle"></i> Profesional asignado automáticamente
                                    </small>
                                </div>
                            </div>
                        </div>

                        <hr />
                        <label><b>Selecciona el Tipo Servicio:</b></label><br />
                        <label className={`btn ${formData.tipo_consulta ? 'btn-info' : 'btn-secondary'}`} style={{ marginRight: '8px' }}>
                            <input type="checkbox" name="tipo_consulta" checked={formData.tipo_consulta} onChange={handleInputChange} className="d-none" />
                            <i className="far fa-calendar-check mr-1"></i> Consulta
                        </label>
                        <label className={`btn ${formData.tipo_procedimiento ? 'btn-info' : 'btn-secondary'}`} style={{ marginRight: '8px' }}>
                            <input type="checkbox" name="tipo_procedimiento" checked={formData.tipo_procedimiento} onChange={handleInputChange} className="d-none" />
                            <i className="fas fa-procedures mr-1"></i> Procedimiento
                        </label>
                    </div>
                </div>

                {showConsulta && (
                    <div className="card card-info card-outline">
                        <div className="card-header"><b>Información de la Consulta</b></div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Código de Consulta *</label>
                                        <div className="input-group">
                                            <input type="text" name="cupsc" className="form-control" placeholder="Seleccione, Haciendo Click en el Icono" value={formData.cupsc} readOnly />
                                            <div className="input-group-append">
                                                <button type="button" className="btn btn-info" onClick={abrirModalConsulta}>
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Diagnóstico Principal *</label>
                                        <div className="input-group">
                                            <input type="text" name="cie10c" className="form-control" placeholder="Seleccione, Haciendo Click en el Icono" value={formData.cie10c} readOnly />
                                            <div className="input-group-append">
                                                <button type="button" className="btn btn-info" onClick={() => abrirModalCIE10('cie10c')}>
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Diagnóstico Relacionado 1</label>
                                        <div className="input-group">
                                            <input type="text" name="cie10c1" className="form-control" value={formData.cie10c1} readOnly />
                                            <div className="input-group-append">
                                                <button type="button" className="btn btn-info" onClick={() => abrirModalCIE10('cie10c1')}>
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Diagnóstico Relacionado 2</label>
                                        <div className="input-group">
                                            <input type="text" name="cie10c2" className="form-control" value={formData.cie10c2} readOnly />
                                            <div className="input-group-append">
                                                <button type="button" className="btn btn-info" onClick={() => abrirModalCIE10('cie10c2')}>
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Diagnóstico Relacionado 3</label>
                                        <div className="input-group">
                                            <input type="text" name="cie10c3" className="form-control" value={formData.cie10c3} readOnly />
                                            <div className="input-group-append">
                                                <button type="button" className="btn btn-info" onClick={() => abrirModalCIE10('cie10c3')}>
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Modalidad de Atención *</label>
                                        <select name="modalidad_consulta" className="form-control" required>
                                            <option value="01">INTRAMURAL</option>
                                            <option value="02">EXTRAMURAL UNIDAD MÓVIL</option>
                                            <option value="03">EXTRAMURAL DOMICILIARIA</option>
                                            <option value="04">EXTRAMURAL JORNADA DE SALUD</option>
                                            <option value="06">TELEMEDICINA INTERACTIVA</option>
                                            <option value="07">TELEMEDICINA NO INTERACTIVA</option>
                                            <option value="08">TELEMEDICINA TELEXPERTICIA</option>
                                            <option value="09">TELEMEDICINA TELEMONITOREO</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Grupo de Servicios *</label>
                                        <select name="grupo_servicios" className="form-control" required>
                                            <option value="01">CONSULTA EXTERNA</option>
                                            <option value="02">APOYO DIAGNÓSTICO Y COMPLEMENTACIÓN TERAPÉUTICA</option>
                                            <option value="03">INTERNACIÓN</option>
                                            <option value="04">QUIRÚRGICO</option>
                                            <option value="05">ATENCIÓN INMEDIATA</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <SearchableSelect
                                        name="servicios"
                                        value={formData.servicios}
                                        onChange={handleInputChange}
                                        options={servicios}
                                        label="Servicios"
                                        placeholder="Seleccione un servicio..."
                                        required={true}
                                        helpText="Busque por código o nombre del servicio"
                                    />
                                </div>
                                <div className="col-md-12">
                                    <SearchableSelect
                                        name="finalidadconsulta"
                                        value={formData.finalidadconsulta}
                                        onChange={handleInputChange}
                                        options={finalidadConsulta}
                                        label="Finalidad Consulta"
                                        placeholder="Seleccione la finalidad..."
                                        helpText="Busque por código o nombre"
                                    />
                                </div>
                                <div className="col-md-12">
                                    <SearchableSelect
                                        name="causaexternaconsulta"
                                        value={formData.causaexternaconsulta}
                                        onChange={handleInputChange}
                                        options={causaExterna}
                                        label="Causa Externa Consulta"
                                        placeholder="Seleccione la causa externa..."
                                        helpText="Busque por código o nombre"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Tipo de Diagnóstico *</label>
                                        <select name="tipo_diagnostico" className="form-control" required>
                                            <option value="01">IMPRESIÓN DIAGNÓSTICA</option>
                                            <option value="02">CONFIRMADO NUEVO</option>
                                            <option value="03">CONFIRMADO REPETIDO</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {showProcedimiento && (
                    <div className="card card-info card-outline">
                        <div className="card-header"><b>Información del Procedimiento</b></div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Código de Procedimiento *</label>
                                        <div className="input-group">
                                            <input type="text" name="cupsp" className="form-control" placeholder="Seleccione, Haciendo Click en el Icono" value={formData.cupsp} readOnly />
                                            <div className="input-group-append">
                                                <button type="button" className="btn btn-info" onClick={abrirModalProcedimiento}>
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Diagnóstico Procedimiento *</label>
                                        <div className="input-group">
                                            <input type="text" name="cie10p" className="form-control" placeholder="Seleccione, Haciendo Click en el Icono" value={formData.cie10p} readOnly />
                                            <div className="input-group-append">
                                                <button type="button" className="btn btn-info" onClick={() => abrirModalCIE10('cie10p')}>
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Diagnóstico Relacionado 1</label>
                                        <div className="input-group">
                                            <input type="text" name="cie10p1" className="form-control" value={formData.cie10p1} readOnly />
                                            <div className="input-group-append">
                                                <button type="button" className="btn btn-info" onClick={() => abrirModalCIE10('cie10p1')}>
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Diagnóstico Complicación</label>
                                        <div className="input-group">
                                            <input type="text" name="cie10pc" className="form-control" value={formData.cie10pc} readOnly />
                                            <div className="input-group-append">
                                                <button type="button" className="btn btn-info" onClick={() => abrirModalCIE10('cie10pc')}>
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Modalidad de Atención *</label>
                                        <select name="modalidad_procedimiento" className="form-control" required>
                                            <option value="01">INTRAMURAL</option>
                                            <option value="02">EXTRAMURAL UNIDAD MÓVIL</option>
                                            <option value="03">EXTRAMURAL DOMICILIARIA</option>
                                            <option value="04">EXTRAMURAL JORNADA DE SALUD</option>
                                            <option value="06">TELEMEDICINA INTERACTIVA</option>
                                            <option value="07">TELEMEDICINA NO INTERACTIVA</option>
                                            <option value="08">TELEMEDICINA TELEXPERTICIA</option>
                                            <option value="09">TELEMEDICINA TELEMONITOREO</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Grupo de Servicios *</label>
                                        <select name="grupo_servicios_procedimientos" className="form-control" required>
                                            <option value="01">CONSULTA EXTERNA</option>
                                            <option value="02">APOYO DIAGNÓSTICO Y COMPLEMENTACIÓN TERAPÉUTICA</option>
                                            <option value="03">INTERNACIÓN</option>
                                            <option value="04">QUIRÚRGICO</option>
                                            <option value="05">ATENCIÓN INMEDIATA</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <SearchableSelect
                                        name="servicios_procedimientos"
                                        value={formData.servicios_procedimientos}
                                        onChange={handleInputChange}
                                        options={servicios}
                                        label="Servicios"
                                        placeholder="Seleccione un servicio..."
                                        required={true}
                                        helpText="Busque por código o nombre del servicio"
                                    />
                                </div>
                                <div className="col-md-12">
                                    <SearchableSelect
                                        name="finalidadprocedimiento"
                                        value={formData.finalidadprocedimiento}
                                        onChange={handleInputChange}
                                        options={finalidadProcedimiento}
                                        label="Finalidad Procedimiento"
                                        placeholder="Seleccione la finalidad..."
                                        helpText="Busque por código o nombre"
                                    />
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Concepto del Recaudo</label>
                                        <select name="conceptoRecaudo" className="form-control" required>
                                            <option value="05">NO APLICA</option>
                                            <option value="01">COPAGO</option>
                                            <option value="02">CUOTA MODERADORA</option>
                                            <option value="03">PAGOS COMPARTIDOS EN PLANES VOLUNTARIOS DE SALUD</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Valor Cuota Moderadora</label>
                                        <input type="number" name="valorpagomoderador" className="form-control" placeholder="0" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Valores de transacción ocultos - se gestionan en ModalDatosFacturacion */}

                <button type="submit" className="btn btn-info">
                    <i className="fas fa-save"></i> Guardar
                </button>
            </form>

            {/* Modal Consultas */}
            {showModalConsulta && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Seleccionar Código de Consulta</h5>
                                <button type="button" className="close" onClick={() => setShowModalConsulta(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th>Código</th>
                                                <th>Nombre</th>
                                                <th>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listaConsultas.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.codigorips}</td>
                                                    <td>{item.nombre}</td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-primary"
                                                            onClick={() => seleccionarConsulta(item)}
                                                        >
                                                            Seleccionar
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalConsulta(false)}>
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Procedimientos */}
            {showModalProcedimiento && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Seleccionar Código de Procedimiento</h5>
                                <button type="button" className="close" onClick={() => setShowModalProcedimiento(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th>Código</th>
                                                <th>Nombre</th>
                                                <th>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listaProcedimientos.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.codigorips}</td>
                                                    <td>{item.nombre}</td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-primary"
                                                            onClick={() => seleccionarProcedimiento(item)}
                                                        >
                                                            Seleccionar
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalProcedimiento(false)}>
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal CIE10 */}
            <ModalCIE10
                show={showModalCIE10}
                onClose={() => setShowModalCIE10(false)}
                onSelect={seleccionarCIE10}
                title="Seleccionar Código CIE10 - Diagnóstico"
            />

            {/* Modal de confirmación de facturación */}
            <ModalConfirmacionFacturacion
                show={showModalConfirmacion}
                onConfirm={handleConfirmacionFacturacion}
                onCancel={() => setShowModalConfirmacion(false)}
            />

            {/* Modal de datos de facturación */}
            <ModalDatosFacturacion
                show={showModalDatosFacturacion}
                onClose={() => setShowModalDatosFacturacion(false)}
                onConfirm={handleConfirmarDatosFacturacion}
                profesionalId={formData.profesionalcode}
                datosRips={datosRipsTemp}
            />

            {/* Borrador RIPS: aviso breve (no ModalRipsExito hasta completar factura) */}
            <Modal show={showModalBorradorExito} onHide={handleCerrarModalBorradorExito} centered backdrop="static" animation>
                <Modal.Header closeButton className="border-0" style={{ background: '#f8f9fa' }}>
                    <Modal.Title className="h6 mb-0 text-dark font-weight-bold">
                        <i className="fas fa-file-alt mr-2 text-info"></i>
                        Borrador de Factura Creado
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="mb-2">La Factura se Genero en Estado <strong>Borrador RIPS</strong>. Complete los Datos en Facturación para Emitir la Factura y Enviar el RIPS.</p>
                    {infoBorrador && (
                        <ul className="list-unstyled small text-muted mb-0">
                       
                            <li><strong>Total:</strong> ${Number(infoBorrador.total).toLocaleString('es-CO')}</li>
                        </ul>
                    )}
                    <p className="small text-info mb-0 mt-3">
                        <i className="fas fa-info-circle mr-1"></i>
                        Listado de facturas → Acciones → <strong>Completar Datos</strong>.
                    </p>
                </Modal.Body>
                <Modal.Footer className="border-0 bg-light">
                    <Button variant="primary" onClick={handleCerrarModalBorradorExito}>
                        Aceptar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Éxito (flujo facturación inmediata / envío DIAN; no borrador) */}
            {ripsGuardado && (
                <ModalRipsExito
                    show={showModalExito}
                    onClose={handleCerrarModal}
                    ripsData={ripsGuardado}
                    onDescargar={handleDescargar}
                    onEnviar={handleEnviar}
                />
            )}

            {/* Modal de confirmación envío a DIAN */}
            {showModalEnvioDian && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header border-0" style={{ background: '#f8f9fa' }}>
                                <h5 className="modal-title text-dark font-weight-bold">
                                    <i className="fas fa-file-invoice mr-2 text-info"></i>
                                    RIPS y Factura Guardados
                                </h5>
                            </div>
                            <div className="modal-body">
                                <div className="text-center mb-3">
                                    <i className="fas fa-file-invoice fa-3x text-secondary mb-3" style={{ opacity: 0.85 }}></i>
                                    <p className="lead">RIPS y Factura guardados exitosamente.</p>
                                </div>
                                <hr />
                                <p className="text-center font-weight-bold">
                                    ¿Desea enviar la factura a la DIAN?
                                </p>
                                <div className="alert alert-info">
                                    <i className="fas fa-info-circle mr-2"></i>
                                    <small>
                                        Si selecciona "Sí", la factura será enviada inmediatamente a la DIAN para su validación.
                                        Si selecciona "No", podrá enviarla más tarde desde el listado de facturas.
                                    </small>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button 
                                    type="button" 
                                    className="btn btn-secondary" 
                                    onClick={handleCancelarEnvioDian}
                                >
                                    <i className="fas fa-times mr-1"></i>
                                    No, enviar después
                                </button>
                                <button 
                                    type="button" 
                                    className="btn btn-primary" 
                                    onClick={handleConfirmarEnvioDian}
                                >
                                    <i className="fas fa-paper-plane mr-1"></i>
                                    Sí, enviar ahora
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de envío en progreso / resultado */}
            {showModalEnviando && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            <div
                                className={`modal-header border-0 ${errorEnvio ? 'border-bottom border-danger' : ''}`}
                                style={{
                                    background: '#f8f9fa',
                                    ...(errorEnvio ? { borderBottomWidth: '3px', borderBottomStyle: 'solid' } : {})
                                }}
                            >
                                <h5 className="modal-title text-dark font-weight-bold">
                                    {errorEnvio ? (
                                        <>
                                            <i className="fas fa-exclamation-triangle mr-2 text-danger"></i>
                                            Error al Enviar a la DIAN
                                        </>
                                    ) : mensajeEnvio.includes('exitosamente') ? (
                                        <>
                                            <i className="fas fa-check-circle mr-2 text-info"></i>
                                            Enviado Exitosamente
                                        </>
                                    ) : (
                                        <>
                                            <i className="fas fa-paper-plane mr-2 text-info"></i>
                                            Enviando a la DIAN
                                        </>
                                    )}
                                </h5>
                            </div>
                            <div className="modal-body">
                                {/* Mensaje principal */}
                                <div className="text-center mb-3">
                                    {mensajeEnvio.includes('Enviando') && !errorEnvio ? (
                                        <div className="spinner-border text-info mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
                                            <span className="sr-only">Enviando...</span>
                                        </div>
                                    ) : errorEnvio ? (
                                        <i className="fas fa-times-circle fa-3x text-danger mb-3"></i>
                                    ) : (
                                        <i className="fas fa-check-circle fa-3x text-info mb-3"></i>
                                    )}
                                    <p className="lead" style={{ whiteSpace: 'pre-wrap' }}>{mensajeEnvio}</p>
                                </div>

                                {/* Detalles del error */}
                                {errorEnvio && (
                                    <>
                                        <hr />
                                        <div className="alert alert-danger">
                                            <h6 className="font-weight-bold">
                                                <i className="fas fa-bug mr-2"></i>
                                                Detalles del Error:
                                            </h6>
                                            
                                            {errorEnvio.status && (
                                                <p className="mb-2">
                                                    <strong>Status HTTP:</strong> {errorEnvio.status} - {errorEnvio.statusText}
                                                </p>
                                            )}
                                            
                                            {errorEnvio.message && (
                                                <p className="mb-2">
                                                    <strong>Mensaje:</strong> {errorEnvio.message}
                                                </p>
                                            )}
                                            
                                            {errorEnvio.data && (
                                                <div className="mt-3">
                                                    <strong>Respuesta del Servidor:</strong>
                                                    <pre className="bg-light p-3 mt-2" style={{ 
                                                        maxHeight: '300px', 
                                                        overflowY: 'auto',
                                                        fontSize: '0.85rem',
                                                        borderRadius: '4px'
                                                    }}>
                                                        {JSON.stringify(errorEnvio.data, null, 2)}
                                                    </pre>
                                                </div>
                                            )}
                                        </div>

                                        <div className="alert alert-info">
                                            <i className="fas fa-lightbulb mr-2"></i>
                                            <strong>Sugerencias:</strong>
                                            <ul className="mb-0 mt-2">
                                                <li>Verifique que los parámetros de facturación electrónica estén configurados correctamente</li>
                                                <li>Revise que todos los datos de la factura sean válidos</li>
                                                <li>Consulte con el administrador del sistema si el error persiste</li>
                                            </ul>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button 
                                    type="button" 
                                    className="btn btn-primary" 
                                    onClick={handleCerrarModalEnviando}
                                >
                                    <i className="fas fa-check mr-1"></i>
                                    Entendido
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}

export default RegistroRipsFev;